import { apiFetch } from '@lib/api/apiClient';

export async function addPoint(formData) {
    const res = await apiFetch('/point/add', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    });

    if (!res.ok) {
        throw new Error('포인트 충전 실패');
    }
    return (await res.json()).data;
}
